import React from "react";
import PropTypes from "prop-types";

function CheckmarkIcon({
  className,
  style,
  fill,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 23 23"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 0C5.148708 0 0 5.148708 0 11.5S5.148708 23 11.5 23 23 17.851292 23 11.5 17.851292 0 11.5 0zm0 21.516129c-5.502565 0-10.016129-4.454163-10.016129-10.016129 0-5.502518 4.454163-10.016129 10.016129-10.016129 5.502564 0 10.016129 4.454163 10.016129 10.016129 0 5.502518-4.454163 10.016129-10.016129 10.016129zm6.56752-12.750208L9.698488 17.06781c-.218175.216413-.570502.215022-.786915-.003154l-3.982246-4.014427c-.216414-.218176-.215023-.570502.003153-.786916l.39508-.39188c.218176-.216414.570502-.215023.786916.003153l3.198484 3.224312 7.578917-7.518125c.218175-.216413.570502-.215022.786915.003153l.391881.395081c.21646.218175.215023.570502-.003153.786915z"
        fill={fill}
        fill-rule="nonzero"
      />
    </svg>
  );
}

CheckmarkIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

CheckmarkIcon.defaultProps = {
  className: undefined,
  defaultHeight: 23,
  defaultWidth: 23,
  fill: "#28EBC1"
};

export default CheckmarkIcon;
